<template>
  <div class="maintenance-mode">
    <img
      class="maintenance-mode__logo"
      src="~@/assets/images/vivense_logo_white.svg"
      :alt="appTitle"
    />

    <div class="maintenance-mode__content">
      <h1
        class="maintenance-mode__content__title"
        v-html="$options.filters.newLineToBr(maintenanceModeContent.title)"
      ></h1>
      <p
        class="maintenance-mode__content__description"
        v-html="
          $options.filters.newLineToBr(maintenanceModeContent.description)
        "
      ></p>
      <p
        class="maintenance-mode__content__caption"
        v-html="$options.filters.newLineToBr(maintenanceModeContent.caption)"
      ></p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppMaintenanceMode',
  data() {
    const { VUE_APP_TITLE, VUE_APP_VIVENSE_URL } = process.env;
    return {
      appTitle: VUE_APP_TITLE,
      vivenseUrl: VUE_APP_VIVENSE_URL,
    };
  },
  computed: {
    maintenanceModeContent() {
      const defaultContent = {
        title: 'Bakım Çalışması Yapıyoruz',
        description:
          'Sizlere daha iyi bir hizmet verebilmek adına\nNetwork Vivense uygulamamızı güncelliyoruz.',
        caption: 'Anlayışınız için teşekkürler...',
      };
      return Object.assign(
        {},
        defaultContent,
        this.$store.getters.getMaintenanceModeContent
      );
    },
  },
};
</script>
